module.exports = __webpack_public_path__ + "static/media/summer-camp.c8820a91.jpeg";